
// // improve this one as well
// // we can use the filtered records view convetion
// import React, { useState, useRef } from "react";

// import { Circles } from "react-loader-spinner";

// const EditableRow = ({
//   handleEditFormSubmit,
//   isLoadingSave,
//   editFormData,
//   handleEditFormChange,
//   handleCancelClick,
//   onStatusChange,
//   names,
//   handleCategoryEdit,
//   optionsPreviledges,
//   contact,foundErrAdd,
// }) => {
//   const [phone, setPhone] = useState(contact.phone);
//   const [username, setUsername] = useState(contact.username);
//   const [email, setEmail] = useState(contact.email);
//   const [farmerID, setFarmerID] = useState(contact.farmerid);

//   const [category, setCategory] = useState(contact.category);
//   const [company, setCompany] = useState(contact.company);

//   //store select values in an array
//   const options = [
//     { value: "", text: "-- select Status --" },
//     { value: "active", text: "active" },
//     { value: "pending", text: "pending" },
//     { value: "disabled", text: "disabled" },
//   ];

//   const companyRef = useRef(contact.company);

//   // const [names, setNames] = useState({
//   //   status: options[0].value,
//   // });

//   return (
//     <tr>
//       <td>{contact.id}</td>
//       <td>
//         <input
//           type="text"
//           placeholder={farmerID}
//           // value={username}
//           // value={contact.username}
//           name="farmerid"
//           onChange={handleEditFormChange}
//         ></input>
//       </td>
//       <td>
//         <input
//           type="text"
//           placeholder={username}
//           // value={username}
//           // value={contact.username}
//           name="username"
//           onChange={handleEditFormChange}
//         ></input>
//       </td>

//       <td>
//         <input
//           type="text"
//           required="required"
//           // placeholder="Edit email"
//           placeholder={email}
//           // value={email}
//           // value={contact.email}
//           name="email"
//           onChange={handleEditFormChange}
//         ></input>
//       </td>

//       <td>
//         <input
//           type="text"
//           placeholder="Edit Password"
//           name="password"
//           onChange={handleEditFormChange}
//         ></input>
//       </td>
//       <td>
//         <input
//           type="text"
//           // pattern="[0-9]*"
//           pattern="[0-9]*"
//           // value={phone}
//           placeholder={phone}
//           onInput={(e) =>
//             setPhone((v) => (e.target.validity.valid ? e.target.value : v))
//           }
//           name="phone"
//           onChange={handleEditFormChange}
//         ></input>
//       </td>
//       <td></td>
//       <td>
//         <input
//           // ref={companyRef}
//           type="text"
//           placeholder={company}
//           // value={company}
//           name="company"
//           onChange={handleEditFormChange}
//         ></input>
//       </td>
//       <td></td>

//       <td>
//         <select
//           className=" f4 bg-white tracked pa2 "
//           value={names.category}
//           onChange={handleCategoryEdit}
//         >
//           {optionsPreviledges.map((option) => (
//             <option key={option.value} value={option.value}>
//               {option.text}
//             </option>
//           ))}
//         </select>
//       </td>
//       <td>
//         <select
//           className=" f4 bg-white tracked pa2 "
//           value={names.status}
//           onChange={onStatusChange}
//         >
//           {options.map((option) => (
//             <option key={option.value} value={option.value}>
//               {option.text}
//             </option>
//           ))}
//         </select>
//       </td>

//       <td>
//        <div className="db">
//         {isLoadingSave ? (
//           <div className="dib ml2 mr2">
//             <Circles type="Oval" color="#000080" height={20} width={40} />
//           </div>
//         ) : null} <div>
//         <button
//           className=" br-pill bw0 bg-orange hover-bg-yellow white pa2"
//           onClick={handleEditFormSubmit}
//         >
//           Save
//         </button>
//         <button
//           type="button"
//           className="ml2 br-pill bw0 bg-orange hover-bg-yellow white pa2"
//           onClick={handleCancelClick}
//         >
//           Cancel
//         </button>
//         </div>
//         <div>
//           <p>
//             {foundErrAdd?"Error!":""}
//           </p>
//         </div>
//         </div>
//       </td>
//     </tr>
//   );
// };

// export default EditableRow;


// new and improved
import React from "react";
import { Circles } from "react-loader-spinner";

const EditableRow = ({
  handleEditFormSubmit,
  isLoadingSave,
  editFormData,
  handleEditFormChange,
  handleCancelClick,
  optionsPreviledges,
  contact,
  foundErrAdd,
}) => {
  // FIX: status options now live here (they only ever applied to this
  // row anyway), and both this select and the category select below are
  // bound directly to editFormData - the same generic handleEditFormChange
  // used everywhere else, instead of the separate onStatusChange/
  // handleCategoryEdit functions that wrote to a disconnected `names`
  // state shared with the Add form.
  const statusOptions = [
    { value: "", text: "-- select Status --" },
    { value: "active", text: "active" },
    { value: "pending", text: "pending" },
    { value: "disabled", text: "disabled" },
  ];

  return (
    <tr>
      {/* Select column placeholder - a row being edited isn't part of
          bulk selection */}
      <td></td>

      <td>{contact.id}</td>

      <td>
        <input
          type="text"
          value={editFormData.farmerid || ""}
          name="farmerid"
          onChange={handleEditFormChange}
        />
      </td>

      <td>
        <input
          type="text"
          value={editFormData.username || ""}
          name="username"
          onChange={handleEditFormChange}
        />
      </td>

      <td>
        <input
          type="text"
          required
          value={editFormData.email || ""}
          name="email"
          onChange={handleEditFormChange}
        />
      </td>

      <td>
        {/* Left uncontrolled/blank on purpose - avoids ever displaying
            the existing plaintext password back into an input */}
        <input
          type="text"
          placeholder="Leave blank to keep current password"
          name="password"
          onChange={handleEditFormChange}
        />
      </td>

      <td>
        <input
          type="text"
          pattern="[0-9]*"
          value={editFormData.phone || ""}
          name="phone"
          onChange={(e) => {
            if (e.target.validity.valid) handleEditFormChange(e);
          }}
        />
      </td>

      <td></td>

      <td>
        <input
          type="text"
          value={editFormData.company || ""}
          name="company"
          onChange={handleEditFormChange}
        />
      </td>

      <td></td>

      <td>
        <select
          className="f4 bg-white tracked pa2"
          value={editFormData.category || ""}
          name="category"
          onChange={handleEditFormChange}
        >
          {optionsPreviledges.map((option) => (
            <option key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
        </select>
      </td>

      <td>
        <select
          className="f4 bg-white tracked pa2"
          value={editFormData.status || ""}
          name="status"
          onChange={handleEditFormChange}
        >
          {statusOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
        </select>
      </td>

      <td>
        <div className="db">
          {isLoadingSave ? (
            <div className="dib ml2 mr2">
              <Circles type="Oval" color="#000080" height={20} width={40} />
            </div>
          ) : null}
          <div>
            <button
              className="br-pill bw0 bg-orange hover-bg-yellow white pa2"
              onClick={handleEditFormSubmit}
              disabled={isLoadingSave}
            >
              {isLoadingSave ? "Saving..." : "Save"}
            </button>
            <button
              type="button"
              className="ml2 br-pill bw0 bg-orange hover-bg-yellow white pa2"
              onClick={handleCancelClick}
            >
              Cancel
            </button>
          </div>
          <div>
            <p>{foundErrAdd ? foundErrAdd : ""}</p>
          </div>
        </div>
      </td>
    </tr>
  );
};

export default EditableRow;